module.exports = __webpack_public_path__ + "13672ad2ec89920a70cf29827b241527.png";